{
	"title": "Налични материали",
	"showAllTitle": "Покажи всички материали",
	"table": {
		"material": "Материал",
		"invoicedQuantity": "Фактурирано количество",
		"remainingForTransfer": "Оставащо за създаване на декларация",
		"fetchError": "Не можа да се извлекат материалите",
		"noMaterials": {
			"title": "Няма налични материали",
			"description": "В момента нямате налични материали в {{productName}}. Моля, свържете се с вашия търговски представител, за да добави вашия договор/договори към акаунта ви."
		}
	}
}
